// Using Intl's dateformatter is more performant than calling date.toLocaleDateString for every date.
// For options, see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
const dateFormatter = new Intl.DateTimeFormat(undefined, {month: 'short', day: 'numeric', year: 'numeric'});
const timeFormatter = new Intl.DateTimeFormat(undefined, {hour: 'numeric', minute: 'numeric', second: 'numeric'});

export function formatDateShort(d: Date): any {
    if (!d || !d.toLocaleDateString) return d;
    return dateFormatter.format(d);
}

export function formatTime(d: Date): any {
    if (!d || !d.toLocaleTimeString) return d;
    return timeFormatter.format(d);
}

export interface ICancelablePromise<T> {
    promise: Promise<T>;
    cancel: () => void;
}

// If canceled, it silently ignores "then" and "catch" callbacks.
// This is useful for ignoring the results of async operations after a component is unmounted.
export function cancelablePromise<T>(p: Promise<T>): ICancelablePromise<T> {
    let isCanceled = false;
    const wrappedP = new Promise<T>((resolve, reject) => {
        p.then((result) => {
                if (!isCanceled) resolve(result);
            })
            .catch((e) => {
                if (!isCanceled) reject(e);
            });
    });

    return {
        promise: wrappedP,
        cancel: () => {
            isCanceled = true;
        }
    }
}